module.exports = __webpack_public_path__ + "static/media/step_1_popup.0b05bf93.png";